import store from "../../store";
import { IModuleParams, IParamAction } from "./paramReducer";

export function updateParam(param: IModuleParams): IParamAction {
    // console.log('updateParam', param);
    // console.log('paramNow', store.getState().progress.params);
    // console.trace();

    return {
        type: "PARAM_UPDATE",
        payload: param,
    }
};

export function clearParam(): IParamAction {
    // console.log('clearParam');
    // console.log('paramNow', store.getState().progress.params);
    console.trace();
    return {
        type: "PARAM_CLEAR"
    }
};